import { Action } from "@ngrx/store";

export const GET_TRANS_PREDICTION_BY_BUILDING_LIST = '[BuildingPrediction] Get trans prediction by building List';
export const GET_TRANS_PREDICTION_BY_BUILDING_LIST_SUCCESS = '[BuildingPrediction] Get trans prediction by building List Success';
export const GET_TRANS_PREDICTION_BY_BUILDING_LIST_FAIL = '[BuildingPrediction] Get trans prediction by building List Fail';
export const CLEAR_TRANS_PREDICTION_BY_BUILDING_LIST = '[BuildingPrediction] Clear trans prediction by building List';

export class GetTransPredictionByBuildingList implements Action {
    readonly type = GET_TRANS_PREDICTION_BY_BUILDING_LIST;
    constructor(public payload: { institutionId: number } = null) { }
}

export class GetTransPredictionByBuildingListSuccess implements Action {
    readonly type = GET_TRANS_PREDICTION_BY_BUILDING_LIST_SUCCESS;
    constructor(public payload: any = null) { }
}

export class GetTransPredictionByBuildingListFail implements Action {
    readonly type = GET_TRANS_PREDICTION_BY_BUILDING_LIST_FAIL;
    constructor(public payload: any = null) { }
}

export class ClearGetTransPredictionByBuildingList implements Action {
    readonly type = CLEAR_TRANS_PREDICTION_BY_BUILDING_LIST;
    constructor(public payload: any = null) { }
}

export type TransPredictionByBuildingActions =
    | GetTransPredictionByBuildingList
    | GetTransPredictionByBuildingListSuccess
    | GetTransPredictionByBuildingListFail
    | ClearGetTransPredictionByBuildingList;